class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((e) => {
      this.onSubmitHandler(e);
    }, 500);

    this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetsWrapperDesktop = this.querySelector("#FacetsWrapperDesktop");
    if (facetsWrapperDesktop) {
      facetsWrapperDesktop.addEventListener("keyup", onKeyUpEscape);
    }

    const facetsButtonShow = this.querySelector(".facets__button-show");
    if (facetsButtonShow) {
      facetsButtonShow.onclick = () => {
        this.querySelector(".facets__wrapper").classList.add("active");
        this.closest(".collection-wrapper").querySelector(".facets-container").classList.add("active");
        this.closest(".collection-wrapper").querySelector(".products-grid__overlay").classList.add("active");
        document.body.classList.add("overflow-hidden");
        this.querySelectorAll(".facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button ").forEach((element) => {
          element.removeAttribute("tabindex");
        });
      };

      this.querySelector(".facets__close").onclick = () => {
        this.querySelector(".facets__wrapper").classList.remove("active");
        this.closest(".collection-wrapper").querySelector(".facets-container").classList.remove("active");
        this.closest(".collection-wrapper").querySelector(".products-grid__overlay").classList.remove("active");
        document.body.classList.remove("overflow-hidden");
        this.querySelectorAll(".facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button ").forEach((element) => {
          element.setAttribute("tabindex", "-1");
        });
      };

      this.querySelector(".products-grid__overlay").onclick = () => {
        this.querySelector(".facets__wrapper").classList.remove("active");
        this.closest(".collection-wrapper").querySelector(".facets-container").classList.remove("active");
        this.closest(".collection-wrapper").querySelector(".products-grid__overlay").classList.remove("active");
        document.body.classList.remove("overflow-hidden");
        this.querySelectorAll(".facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button ").forEach((element) => {
          element.setAttribute("tabindex", "-1");
        });
      };

      window.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") {
          this.querySelector(".facets__wrapper").classList.remove("active");
          this.closest(".collection-wrapper").querySelector(".facets-container").classList.remove("active");
          this.closest(".collection-wrapper").querySelector(".products-grid__overlay").classList.remove("active");
          document.body.classList.remove("overflow-hidden");
          this.querySelectorAll(".facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button ").forEach((element) => {
            element.setAttribute("tabindex", "-1");
          });
        }
      });
    }

    document.addEventListener("click", (event) => {
      const facetsDisclosures = document.querySelectorAll(".facets__wrapper--horizontal .facets__disclosure");
      const openFacet = event.target.closest(".facets__disclosure[open]");
      const facetsWrapperHorizontalUnited = document.querySelector(".facets__wrapper--horizontal_united");
      const closestFacetsWrapperHorizontalUnited = event.target.closest(".facets__wrapper--horizontal_united");
      const closestLoadingOverlay = event.target.closest(".loading-overlay");

      if (
        facetsWrapperHorizontalUnited && 
        facetsWrapperHorizontalUnited != closestFacetsWrapperHorizontalUnited &&
        !event.target.closest(".facets__reset ") &&
        document.querySelector(".facets__button-show") != event.target.closest(".facets__button-show") &&
        document.querySelector(".loading-overlay") != closestLoadingOverlay
      ) {
        facetsWrapperHorizontalUnited.classList.remove("active");
        if (event.target.closest(".products-grid__overlay")) {
          event.target.closest(".products-grid__overlay").classList.remove("active");
        }
        document.body.classList.remove("overflow-hidden");
      }

      if (!openFacet && facetsDisclosures) {
        facetsDisclosures.forEach((disclosure) => {
          disclosure.removeAttribute("open");
        });
      }
    });
  }

  static calcMinHeight = () => {
    const facetsTop = document.querySelector(".facets__top");
    const facetsSortWrapper = document.querySelector(".facets__sort-wrapper");
    const collectionWrapper = document.querySelector(".collection-wrapper");

    if (facetsTop && facetsSortWrapper && collectionWrapper) {
      if (facetsSortWrapper.getBoundingClientRect().height > facetsTop.getBoundingClientRect().height) {
        collectionWrapper.style.gridTemplateRows = facetsSortWrapper.getBoundingClientRect().height + "px auto 1fr";
      } else {
        collectionWrapper.style.gridTemplateRows = facetsTop.getBoundingClientRect().height + "px auto 1fr";
      }
    }
  };

  static setListeners() {
    window.addEventListener("popstate", (event) => {
      console.log("facets popstate", event.state)
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams !== FacetFiltersForm.searchParamsPrev) {
        FacetFiltersForm.renderPage(searchParams, null, false);
      }
    });
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");
    const buttonResults = document.querySelector(".button--results");

    document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading");

    if (countContainer) {
      countContainer.classList.add("loading");
    }

    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    } else {
      document.querySelector(".loading-overlay").style.top = "0";
    }

    if (buttonResults) {
      buttonResults.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }

    if (window.resetInfiniteScroll) {
      window.resetInfiniteScroll()
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html: responseText,
          url: url
        }];
        FacetFiltersForm.renderFilters(responseText, event);
        FacetFiltersForm.renderProductGridContainer(responseText);
        FacetFiltersForm.renderProductCount(responseText);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    if (document.querySelector(".js-load-more") || document.querySelector(".js-infinite-scroll")) {
      loadMore();
    }
    colorSwatches();
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;

    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    const buttonResults = document.querySelector(".button--results");

    container.innerHTML = count;
    container.classList.remove("loading");

    if (buttonResults) {
      buttonResults.classList.remove("loading");
    }

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }

    document.querySelectorAll(".facets__wrapper details, .facets__wrapper a, .facets__wrapper input, .facets__wrapper button ").forEach((element) => {
      element.removeAttribute("tabindex");
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElements = parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter");

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) {
      FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter"));
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets-desktop"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (activeFacetsElement) {
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        FacetFiltersForm.calcMinHeight();
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML = source.querySelector(".facets__selected").outerHTML;
    }

    if (targetSummary && sourceSummary) {
      target.querySelector(".facets__summary").outerHTML = source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
  }

  static getSections() {
    return [{
      section: document.getElementById("product-grid").dataset.id
    }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const forms = document.querySelectorAll("facet-filters-form form");

    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(event.target.closest("form"));
      this.onSubmitForm(searchParams, event);
    } else {
      const formParams = [];
      forms.forEach((form) => {
        if (form.id === "FacetSortForm" || form.id === "FacetFiltersForm" || form.id === "FacetSortDrawerForm") {
          document.querySelectorAll(".no-js-list").forEach((element) => element.remove());
          formParams.push(this.createSearchParams(form));
        }
      });

      this.onSubmitForm(formParams.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf("?") === -1 ? "" : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => element.addEventListener("change", this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) {
      minInput.setAttribute("max", maxInput.value);
    }
    if (minInput.value) {
      maxInput.setAttribute("min", minInput.value);
    }
    if (minInput.value === "") {
      maxInput.setAttribute("min", 0);
    }
    if (maxInput.value === "") {
      minInput.setAttribute("max", maxInput.getAttribute("max"));
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) {
      input.value = min;
    }
    if (value > max) {
      input.value = max;
    }
  }

  fillSlider() {
    document.querySelectorAll(".facets__price .facets__range").forEach((parent) => {
      const rangeInputs = parent.querySelectorAll(".field__range");
      const rangeMin = rangeInputs[0];
      const rangeMax = rangeInputs[1];

      const range = rangeMax.max - rangeMax.min;
      const minPosition = rangeMin.value - rangeMax.min;
      const maxPosition = rangeMax.value - rangeMax.min;

      parent.setAttribute("style", `--range-min: ${(minPosition / range) * 100}%; --range-max: ${(maxPosition / range) * 100}%`);
    });
  }

  controlSlider() {
    const rangeInputs = document.querySelectorAll(".facets__price .facets__range");
    const numberInputs = document.querySelectorAll(".facets__price .facets__price-wrapper");

    rangeInputs.forEach((parent, index) => {
      const rangeInput = parent.querySelectorAll(".field__range");
      const numberMin = rangeInput[0];
      const numberMax = rangeInput[1];
      const inputMin = numberInputs[index].querySelectorAll(".field__input")[0];
      const inputMax = numberInputs[index].querySelectorAll(".field__input")[1];

      numberMin.oninput = () => {
        const valueMin = Number(numberMin.value);
        const valueMax = Number(numberMax.value);

        if (valueMax < valueMin) {
          numberMin.value = valueMax;
          inputMin.value = valueMax;
        } else {
          inputMin.value = valueMin;
        }
        this.fillSlider();
      };

      if (Number(numberMax.value) <= 0) {
        numberMax.style.zIndex = 2;
      } else {
        numberMax.style.zIndex = 0;
      }

      numberMax.oninput = () => {
        const valueMin = Number(numberMin.value);
        const valueMax = Number(numberMax.value);

        if (valueMin <= valueMax) {
          numberMax.value = valueMax;
          inputMax.value = valueMax;
        } else {
          inputMax.value = valueMin;
          numberMax.value = valueMin;
        }

        if (Number(numberMax.value) <= 0) {
          numberMax.style.zIndex = 2;
        } else {
          numberMax.style.zIndex = 0;
        }

        this.fillSlider();
      };
    });
  }

  controlInput() {
    const rangeInputs = document.querySelectorAll(".facets__price .facets__range");
    const numberInputs = document.querySelectorAll(".facets__price .facets__price-wrapper");

    numberInputs.forEach((parent, index) => {
      const numberInput = parent.querySelectorAll(".field__input");
      const inputMin = numberInput[0];
      const inputMax = numberInput[1];
      const rangeMin = rangeInputs[index].querySelectorAll(".field__range")[0];
      const rangeMax = rangeInputs[index].querySelectorAll(".field__range")[1];

      inputMin.oninput = () => {
        const valueMin = parseInt(inputMin.value, 10);
        const valueMax = parseInt(inputMax.value, 10);

        if (valueMax < valueMin) {
          rangeMin.value = valueMax;
          inputMin.value = valueMax;
        } else {
          rangeMin.value = valueMin;
        }
        this.fillSlider();
      };

      inputMax.oninput = () => {
        const valueMin = parseInt(inputMin.value, 10);
        const valueMax = parseInt(inputMax.value, 10);

        if (valueMin <= valueMax) {
          rangeMax.value = valueMax;
          inputMax.value = valueMax;
        } else {
          inputMax.value = valueMin;
        }
        this.fillSlider();
      };
    });
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const buttonElement = this.querySelector("a");
    buttonElement.setAttribute("role", "button");
    buttonElement.addEventListener("click", this.closeFilter.bind(this));
    buttonElement.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") {
        this.closeFilter(event);
      }
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);